import React, { useState } from "react";
import { Form, Col } from "react-bootstrap";
import naukricom from ".././assets/images/icon/nakricom.svg";
import linkedins from ".././assets/images/icon/linkedin.svg";
import indeed from ".././assets/images/icon/indeed.svg";
import monster from ".././assets/images/icon/monster.svg";
import { useTranslation } from "react-i18next";

const JobPublishForm = ({ checkedPlatforms, setCheckedPlatforms }) => {
  const { t } = useTranslation();

  const handleSelectAllChange = e => {
    const isChecked = e.target.checked;
    setCheckedPlatforms({
      all: isChecked,
      naukri: isChecked,
      linkedin: isChecked,
      indeed: isChecked,
      monster: isChecked,
    });
  };

  const handlePlatformChange = platform => e => {
    const isChecked = e.target.checked;
    setCheckedPlatforms(prevState => {
      const newState = { ...prevState, [platform]: isChecked };
      const allChecked = Object.values(newState).slice(1).every(Boolean);
      return {
        ...newState,
        all: allChecked,
      };
    });
  };

  //console.log("checkedPlatforms", checkedPlatforms);

  return (
    <Col lg={12}>
      <Form.Group className="mb-4 mt-3 position-relative publish-jobs-cards">
        <Form.Label>{t(`Edit Job.Publish Job Text`)}</Form.Label>
        <div className="job-across-list">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              checked={checkedPlatforms.all}
              onChange={handleSelectAllChange}
              id="flexCheckDefaultAll"
            />
            <label className="form-check-label" htmlFor="flexCheckDefaultAll">
              {t(`Edit Job.All`)}
            </label>
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              checked={checkedPlatforms.naukri}
              onChange={handlePlatformChange("naukri")}
              id="flexCheckDefaultNaukri"
            />
            <label
              className="form-check-label"
              htmlFor="flexCheckDefaultNaukri"
            >
              <img src={naukricom} />
            </label>
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              checked={checkedPlatforms.linkedin}
              onChange={handlePlatformChange("linkedin")}
              id="flexCheckDefaultLinkedin"
            />
            <label
              className="form-check-label"
              htmlFor="flexCheckDefaultLinkedin"
            >
              <img src={linkedins} />
            </label>
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              checked={checkedPlatforms.indeed}
              onChange={handlePlatformChange("indeed")}
              id="flexCheckDefaultIndeed"
            />
            <label
              className="form-check-label"
              htmlFor="flexCheckDefaultIndeed"
            >
              <img src={indeed} />
            </label>
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              checked={checkedPlatforms.monster}
              onChange={handlePlatformChange("monster")}
              id="flexCheckDefaultMonster"
            />
            <label
              className="form-check-label"
              htmlFor="flexCheckDefaultMonster"
            >
              <img src={monster} />
            </label>
          </div>
        </div>
      </Form.Group>
    </Col>
  );
};

export default JobPublishForm;
